import React from 'react';
import Typography from '../Text/Typography';
import './Radio.css';

interface RadioProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string | React.ReactNode;
  labelVariant?: 'body' | 'body-small' | 'body-small-bold';
  name: string;
  value: string;
  id?: string;
  disabled?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

const Radio: React.FC<RadioProps> = ({ 
  checked, 
  onChange, 
  label, 
  labelVariant = 'body',
  name,
  value,
  id, 
  disabled = false,
  className,
  style 
}) => {
  const containerClass = `radio-container ${disabled ? 'disabled' : ''} ${className || ''}`.trim();
  const radioClass = `radio-custom${checked ? ' checked' : ''}${disabled ? ' disabled' : ''}`;

  return (
    <label className={containerClass} htmlFor={id} style={style}>
      <input
        id={id}
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={e => onChange(e.target.checked)}
        className="radio-input"
        disabled={disabled}
      />
      <span className={radioClass}></span>
      {label && (
        <Typography variant={labelVariant} className="radio-label">
          {label}
        </Typography>
      )}
    </label>
  );
};

export default Radio; 